import BaseApi from "../baseApi";
import {TASK_ACTIVITY} from "../apiConstant";

const apiWorkManage = new BaseApi(process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL);

class TaskActivityApi {
  createTaskActivity(request) {
    return apiWorkManage.post(`${TASK_ACTIVITY}/comment-reply`, request);
  }

  updateTaskActivity(taskActivityCode, request) {
    return apiWorkManage.put(`${TASK_ACTIVITY}/update-comment/${taskActivityCode}`, request)
  }

  deleteTaskActivity(taskActivityCode, request) {
    return apiWorkManage.post(`${TASK_ACTIVITY}/delete-comment/${taskActivityCode}`, request)
  }

  getList(request) {
    return apiWorkManage.post(`${TASK_ACTIVITY}/list`, request);
  }

  getCommentListHistory(request) {
    return apiWorkManage.post(`${TASK_ACTIVITY}/list-history`, request);
  }

  getChildList(request) {
    return apiWorkManage.post(`${TASK_ACTIVITY}/child-list`, request);
  }

  getProjectDetail(request) {
    return apiWorkManage.post(`${TASK_ACTIVITY}/detail`, request);
  }

}

export default TaskActivityApi;